import { CanvasDelegate2sttw7eh6wg08 as CanvasDelegate } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Canvas.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import {
  set_fillPaint17d1uil08islv as set_fillPaint,
  get_width2jz337ntc0974 as get_width,
  get_height2o8bnqi51rulq as get_height,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/canvas/DrawingContext2D.js.mjs';
import { Companion_getInstancec4l82qvpwbuq as Companion_getInstance } from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReady_instance37iasaqvolrrz as InternalReactiveNotReady_instance,
} from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ProgressDelegateClass;
function ProgressDelegate() {
  if (ProgressDelegateClass === VOID) {
    class $ extends CanvasDelegate() {
      static xga(color, progress) {
        var $this = this.ud9();
        $this.vga_1 = color;
        $this.wga_1 = progress;
        return $this;
      }
      static yga(color, progress) {
        return this.xga(new (Constant())(_Constant___init__impl__v45mub(color)), new (Constant())(_Constant___init__impl__v45mub(progress)));
      }
      wd9(context) {
        set_fillPaint(context, AppColors_getInstance().hfz_1.bga_1);
        context.fillRect(0.0, 0.0, get_width(context), get_height(context));
        Companion_getInstance();
        var tmp2 = this.vga_1;
        var tmp4 = this.wga_1;
        $l$block_2: {
          // Inline function 'com.crowpay.utils.combineOrNull' call
          // Inline function 'com.crowpay.utils.getOrElse' call
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
          var this_0 = tmp2.sah();
          var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
          var tmp;
          if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
            break $l$block_2;
          } else {
            if (tmp0_subject instanceof InternalReactiveThrownException()) {
              _ReactiveState___get_raw__impl__92ipya(this_0).uah_1;
              break $l$block_2;
            } else {
              if (tmp0_subject instanceof InternalReactiveWrapper()) {
                var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0).tah_1;
                tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
              } else {
                tmp = _ReactiveState___get_raw__impl__92ipya(this_0);
              }
            }
          }
          var r1 = tmp;
          // Inline function 'com.crowpay.utils.getOrElse' call
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
          var this_1 = tmp4.sah();
          var tmp0_subject_0 = _ReactiveState___get_raw__impl__92ipya(this_1);
          var tmp_1;
          if (equals(tmp0_subject_0, InternalReactiveNotReady_instance)) {
            break $l$block_2;
          } else {
            if (tmp0_subject_0 instanceof InternalReactiveThrownException()) {
              _ReactiveState___get_raw__impl__92ipya(this_1).uah_1;
              break $l$block_2;
            } else {
              if (tmp0_subject_0 instanceof InternalReactiveWrapper()) {
                var tmp_2 = _ReactiveState___get_raw__impl__92ipya(this_1).tah_1;
                tmp_1 = (tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE();
              } else {
                tmp_1 = _ReactiveState___get_raw__impl__92ipya(this_1);
              }
            }
          }
          var r2 = tmp_1;
          set_fillPaint(context, r1);
          var tmp0 = get_width(context);
          // Inline function 'kotlin.comparisons.minOf' call
          var b = get_width(context) * r2;
          var tmp$ret$11 = Math.min(tmp0, b);
          context.fillRect(0.0, 0.0, tmp$ret$11, get_height(context));
        }
      }
    }
    initMetadataForClass($, 'ProgressDelegate');
    ProgressDelegateClass = $;
  }
  return ProgressDelegateClass;
}
//region block: exports
export {
  ProgressDelegate as ProgressDelegate2saexiliay2do,
};
//endregion

//# sourceMappingURL=ProgressDelegate.mjs.map
